import { GoArrowUpRight } from "react-icons/go";

import type { FeedbackGoal } from "@/types/simulations";

import { Button } from "@/components/Button";

interface GoalMessageProps {
  goals: FeedbackGoal[];
  onClick: () => void;
}

const GoalMessage = ({ goals, onClick }: GoalMessageProps) => {
  const isFail = goals?.every(item => !item.achieved)

  if (isFail || !goals?.length) {
    return getFailedFeedbackMessage(goals);
  }

  const achievedGoals = goals.filter(goal => goal.achieved);
  const [firstGoal] = achievedGoals;
  const isMultiple = achievedGoals.length > 1;

  let successDetailElement = <span className="font-semibold">{firstGoal.name}</span>

  if (isMultiple) {
    successDetailElement = (
      <>
        the <span className="font-semibold">{achievedGoals.length} GOALS</span>
      </>
    );
  }

  return (
    <>
      <p className="text-[#393938]">
        <span className="font-semibold text-brandPrimaryGreen">
          You did it!
        </span>{" "}
        Congratulations on {successDetailElement}. Keep practicing to master all!
      </p>

      {isMultiple && (
        <Button
          variant="text"
          onClick={onClick}
          label="Click here to read more"
          icon={<GoArrowUpRight size={22} />}
          className="text-buttonOrange hover:underline [&>span]:text-base font-medium p-0 border-0 flex-row-reverse outline-none"
        />
      )}
    </>
  );
};

export default GoalMessage

// ----------------------------

const FEEDBACK_MESSAGES = {
  empty: {
    title: "There is no goal analysis available for this simulation.",
    description: ""
  },
  failed: {
    title: "No goals were achieved in this simulation.",
    description: "Keep practicing, you're on the right track!"
  }
}

function getFailedFeedbackMessage(goals: FeedbackGoal[]) {
  const { title, description } = !goals.length ? FEEDBACK_MESSAGES.empty : FEEDBACK_MESSAGES.failed;

  return (
    <p className="text-[#393938]">
      <span className="font-semibold text-buttonDarkRed">{title}</span> {description}
    </p>
  )
}